<template>
  <div class="row mx-0">
    <div
      class="col-lg-6 col-md-5 col-sm-5 pt-2 login-img d-flex align-items-center justify-content-center"
    >
      <img
        :alt="Logo"
        :aria-label="Logo"
        src="/images/makbilllogo.png"
        class="img-fluid1"
      />
    </div>
    <div class="col-lg-5 col-md-6 col-sm-6 justify-content-center m-lg-4 register-form">
      <h3 class="text-center fw-bold m-4">Registration</h3>
      <form ref="loginForm" class="d-grid md-m-2" @submit.prevent="register">
        <div class="row mb-2">
          <div>
            <llp-label>Member Type:</llp-label>
            <llp-radio
              id="sendOptions"
              v-model="selectedTypeOption"
              :options="[
                { id: 'individual', name: 'Individual' },
                { id: 'company', name: 'Company' },
                { id: 'partnership', name: 'Partnership' },
              ]"
              autocomplete="off"
            ></llp-radio>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
            <llp-label id="firstname" :aria-label="Firstname"
              >First Name:</llp-label
            >
            <llp-input
              id="firstname"
              class="w-100"
              autocomplete="off"
              v-model="firstName"
              :errors="validator.firstName.$errors"
            ></llp-input>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
            <llp-label id="lastname" :aria-label="Lastname"
              >Last Name:</llp-label
            >
            <llp-input
              id="lastname"
              class="w-100"
              autocomplete="off"
              v-model="lastName"
              :errors="validator.lastName.$errors"
            ></llp-input>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
            <llp-label id="emaillabel" :aria-label="email">Email:</llp-label>
            <llp-input
              id="email"
              class="w-100"
              autocomplete="off"
              v-model="email"
              :errors="validator.email.$errors"
              @input="clearError('email')"
            ></llp-input>
            <div v-if="formErrors.email" class="text-danger">
              <span>{{ formErrors.email[0] }}</span>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
            <llp-label id="mobileLabel" :aria-label="Mobile">Mobile:</llp-label>
            <llp-input
              id="mobileInput"
              class="w-100"
              autocomplete="off"
              v-model="mobileNumber"
              :errors="validator.mobileNumber.$errors"
              @input="clearError('mobile')"
            ></llp-input>
            <div v-if="formErrors.mobile" class="text-danger">
              <span>{{ formErrors.mobile[0] }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
            <llp-label id="addressLabel" :aria-label="address"
              >Address:</llp-label
            >
            <llp-input
              id="address"
              class="w-100"
              autocomplete="off"
              v-model="address"
              :errors="validator.address.$errors"
            ></llp-input>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <llp-label id="cityLabel" :aria-label="City">City:</llp-label>
            <llp-input
              id="cityInput"
              class="w-100"
              autocomplete="off"
              v-model="city"
              :errors="validator.city.$errors"
            ></llp-input>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6">
            <llp-label id="state" :aria-label="State"> State: </llp-label>
            <select
              id="state"
              class="form-control select-dropdown"
              v-model="state"
            >
              <option value="" disabled selected>Select your state</option>
              <option value="Andhra Pradesh">Andhra Pradesh</option>
              <option value="Arunachal Pradesh">Arunachal Pradesh</option>
              <option value="Assam">Assam</option>
              <option value="Bihar">Bihar</option>
              <option value="Chhattisgarh">Chhattisgarh</option>
              <option value="Goa">Goa</option>
              <option value="Gujarat">Gujarat</option>
              <option value="Haryana">Haryana</option>
              <option value="Himachal Pradesh">Himachal Pradesh</option>
              <option value="Jammu and Kashmir">Jammu and Kashmir</option>
              <option value="Jharkhand">Jharkhand</option>
              <option value="Karnataka">Karnataka</option>
              <option value="Kerala">Kerala</option>
              <option value="Madhya Pradesh">Madhya Pradesh</option>
              <option value="Maharashtra">Maharashtra</option>
              <option value="Manipur">Manipur</option>
              <option value="Meghalaya">Meghalaya</option>
              <option value="Mizoram">Mizoram</option>
              <option value="Nagaland">Nagaland</option>
              <option value="Odisha">Odisha</option>
              <option value="Punjab">Punjab</option>
              <option value="Rajasthan">Rajasthan</option>
              <option value="Sikkim">Sikkim</option>
              <option value="Tamil Nadu">Tamil Nadu</option>
              <option value="Telangana">Telangana</option>
              <option value="Tripura">Tripura</option>
              <option value="Uttar Pradesh">Uttar Pradesh</option>
              <option value="Uttarakhand">Uttarakhand</option>
              <option value="West Bengal">West Bengal</option>
              <option value="Chandigarh">Chandigarh</option>
              <option value="Lakshadweep">Lakshadweep</option>
              <option value="Delhi">Delhi</option>
              <option value="Puducherry">Puducherry</option>
            </select>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
            <llp-label id="pincodeLabel" :aria-label="Pincode"
              >Pincode:</llp-label
            >
            <llp-input
              id="pincode"
              class="w-100"
              autocomplete="off"
              v-model="pinCode"
              :errors="validator.pinCode.$errors"
              @input="clearError('pincode')"
            ></llp-input>
            <div v-if="formErrors.pincode" class="text-danger">
              <span>{{ formErrors.pincode[0] }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
            <llp-label id="passwordLabel" :aria-label="Password"
              >Password:</llp-label
            >
            <llp-input
              id="password"
              v-model="password"
              :errors="validator.password.$errors"
              type="password"
              class="w-100"
              autocomplete="off"
              @input="clearError('password')"
            ></llp-input>
            <div v-if="formErrors.password" class="text-danger">
              <span>{{ formErrors.password[0] }}</span>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <llp-label id="confirmPasswordLabel" :aria-label="confirPassword"
              >Confirm Password:</llp-label
            >
            <llp-input
              id="confirmpassword"
              class="w-100"
              autocomplete="off"
              v-model="confirmPassword"
              :errors="validator.confirmPassword.$errors"
              type="password"
            ></llp-input>
          </div>
        </div>
        <div
          class="row"
          v-if="
            selectedTypeOption === 'company' ||
            selectedTypeOption === 'partnership'
          "
        >
          <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
            <llp-label id="companyNameLabel" :aria-label="companyName"
              >Company Name:</llp-label
            >
            <llp-input
              id="companyName"
              class="w-100"
              autocomplete="off"
              v-model="companyName"
            ></llp-input>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
            <llp-label id="companyAddressLabel" :aria-label="companyAddress"
              >Company Address:</llp-label
            >
            <llp-input
              id="companyAddress"
              class="w-100"
              autocomplete="off"
              v-model="companyAddress"
            ></llp-input>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
            <llp-button
              :loadSpinner="showLoginSpinner"
              classNames="btn-secondary text-white new-btn"
              type="submit"
              >Register</llp-button
            >
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
            <llp-button
              classNames="btn-secondary text-white new-btn"
              @click="BackToLogin()"
              >Back To Login</llp-button
            >
          </div>
        </div>
      </form>
    </div>
  </div>

  <llp-toast ref="toast"></llp-toast>
</template>
<script>
import { helpers, required, numeric, maxLength } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import ErrorService from "../../services/error.service";
import NetworkService from "@/services/network.service";
// import axios from "axios";
export default {
  setup: () => ({ validator: useVuelidate() }),
  data() {
    return {
      selectedTypeOption: "individual",
      firstName: "",
      lastName: "",
      state: "",
      city: "",
      address: "",
      companyName: "",
      email: "",
      mobileNumber: "",
      pinCode: "",
      password: "",
      confirmPassword: "",
      userType: "",
      companyAddress: "",
      formErrors: {},
      showLoginSpinner: false,
    };
  },
  validations() {
    return {
      firstName: {
        required: helpers.withMessage("First name is required.", required),
         alphaOnly: helpers.withMessage(
          "First name should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
      },
      lastName: {
        required: helpers.withMessage("Last name is required.", required),
          alphaOnly: helpers.withMessage(
          "Last name should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
      },
      email: { required: helpers.withMessage("Email is required.", required) ,
         emailFormat: helpers.withMessage(
        "Please enter a valid email address.",
        (value) => (value ? /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(value) : true)
      ),
      },
      mobileNumber: {
        required: helpers.withMessage("Mobile number is required.", required),
        numeric: helpers.withMessage("Mobile number must be numeric.", numeric),
        maxLength: helpers.withMessage(
          "Mobile number must be 10 digits.",
          maxLength(10)
        ),
        validMobile: helpers.withMessage(
          "Mobile number must start with 6, 7, 8, or 9.",
          (value) => (value ? /^[6789]\d{9}$/.test(value) : true)
        ),
      },
      address: {
        required: helpers.withMessage("Address is required.", required),
      },
      city: { required: helpers.withMessage("City is required.", required),
        alphaOnly: helpers.withMessage(
          "City should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
       },
        
     pinCode: {
          required: helpers.withMessage("Pin code is required.", required),
           numeric: helpers.withMessage("Pin code must contain only numbers.", numeric),
  maxLength: helpers.withMessage("Pin code must be 6 digits.", maxLength(6)),
        },
      password: {
        required: helpers.withMessage("Password is required.", required),
      },
      confirmPassword: {
        required: helpers.withMessage(
          "Confirm password is required.",
          required
        ),
        sameAsPassword: helpers.withMessage(
          "Confirm password must be the same as password.",
          (value) => value === this.password
        ),
      },
    };
  },
  methods: {
    async register() {
      this.validator
        .$validate()
        .then(async (isValid) => {
          if (!isValid) return Promise.reject();

          if (this.selectedTypeOption === "individual") {
            this.userType = 1;
          } else if (this.selectedTypeOption === "company") {
            this.userType = 2;
          } else if (this.selectedTypeOption === "partnership") {
            this.userType = 3;
          }
          this.showLoginSpinner = true;
          const payload = {
            name: this.firstName,
            first_name: this.firstName,
            last_name: this.lastName,
            email: this.email,
            mobile: this.mobileNumber,
            address: this.address,
            city: this.city,
            state: this.state,
            pincode: this.pinCode,
            password: this.password,
            usertype: this.userType,
          };
          if (
            this.selectedTypeOption === "company" ||
            this.selectedTypeOption === "partership"
          ) {
            payload.company_name = this.companyName;
            payload.company_address = this.companyAddress;
          }
          try {
            const response = await NetworkService.post(
              "user-register",
              payload
            );
            this.formErrors = {};
            this.$refs.toast.show(response.data.message);
            if (response.data.success) {
              localStorage.setItem("needsDocumentVerification", "true");
             setTimeout(() => {
               this.$router.push({
                name: "document-verification",
                query: {
                  id: response.data.id,
                  token: response.data.token,
                },
              });
             }, 2000);
            }
             this.showLoginSpinner = false;
          } catch (error) {
            if (error.errors) {
             this.showLoginSpinner = false;
              this.formErrors = error.errors;
            } else {
              this.$refs.toast.show("Unable to register.", "error");
            }
          }
        })
        .catch((error) => {
          this.$refs.toast.show(ErrorService.getErrorMessages(error), "error");
        });
    },
    clearError(field) {
      this.formErrors[field] = [];
    },
    BackToLogin() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>
